<template>
    <el-col :span="$vuetify.display.width >= 700 ? 24 : 24" :class="$vuetify.display.width < 700 ? 'py-2 x-center' : 'height-100-p'" :style="$vuetify.display.width < 630 ? 'max-width: 100%; x-center;' : ''">
        <div class="custom-table-design" :style="$vuetify.display.width < 700 ? 'min-width: 250px; max-width: 90%;' : ''">
          <el-table 
            :data="tableData"
            stripe
            scrollbar-always-on: false
            class="my-2 data-table"
            :width="$vuetify.display.width >= 700 ? '100%': ''"
            :style="$vuetify.display.width < 700 ? 'min-width: 250px; max-width: 100%;' : ''"
            >
            <el-table-column
              v-for="column in tableColumns"
              :key="column.prop"
              :label="column.label"
              :prop="column.prop"
              :width="$vuetify.display.width <= 630 ? 120 : $vuetify.display.width <= 1400 ? 200 :  180"
            >
            </el-table-column>
          </el-table>
          </div>
      </el-col>
   
  </template>
  
  <script>



  export default {
    props: {
        tableData: {
            type: Array,
            default: () => []
        },
        tableColumns: {
            type: Array,
            default: () => []
        },
    },
  };
  </script>
  